<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/BkgdM2/tc-custom/9781497683914.jpg?1705025862296" alt="This image is the cover for the book Cuts"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Cuts
      </h1>
      <p class="bookDescription body article font2">
        <b>Looking to strike it rich with television gold, an English media tycoon enlists the help of an unassuming novelist to script his small-screen epic, to disastrous—and hilarious—effect</b><br/><br/> The year is 1986, and the cuts imposed by Margaret Thatcher’s government have trickled down to university life, where departments are being forced to shave their payrolls to account for reduced public funding. Meanwhile, at Eldorado Television, a different kind of cut is about to wreak havoc. Lord Mellow, head of the declining studio, watches as his last-ditch effort to produce a hit series falls to pieces. The show’s star, the volatile but vaunted Sir Luke Trimingham, has just declared that he will quit unless the script is entirely rewritten. Desperate to save the project, Eldorado brings university lecturer and author Henry Babbacombe into the fold to write thirteen new episodes of ambitious television—something so grand that the leading man cannot possibly refuse it. But the production is plagued from the start, suffering endless calamities with its unpredictable actors and crew, whose behind-the-scenes drama rivals anything Babbacombe could dream up. 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Malcolm Bradbury
      </h2>
      
      <p class="authorDescription body article">Malcolm Bradbury (1932&ndash;2000) was a well-known novelist, critic, and academic, as well as founder of the creative writing department at the University of East Anglia. His seven novels include&#160;<I>The History Man</I>&#160;and&#160;<I>Rates of Exchange</I>,&#160;which was shortlisted for the Man Booker Prize. Bradbury was knighted in 2000 for services to literature and died the same year.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?416751dd